import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en/translation.json';
import lv from './locales/lv/translation.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'lv',
    supportedLngs: ['lv', 'en'], // ✅ ensure only valid keys are used
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'], // stores selected language
    },
    resources: {
      en: { translation: en },
      lv: { translation: lv },
    },
  });

export default i18n;
